// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("dist/" + chunkId + ".QWC2App.js");